var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconeHandholdingplant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Graphic_Elements",
    "data-name": "Graphic Elements",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 1200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #fff;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 28px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M953.34,185.74s-411.28-65.58-346.39,346.39c411.98,64.89,346.39-346.39,346.39-346.39Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 845.87,
    y1: 293.2,
    x2: 606.94,
    y2: 532.13
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M246.66,185.74s411.28-65.58,346.39,346.39C181.08,597.02,246.66,185.74,246.66,185.74Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 368.03,
    y1: 307.11,
    x2: 593.06,
    y2: 532.13
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M625.69,707.1c-6.7-38.28-13.59-96.77-16.24-182.33h-18.9c-3.21,103.57-12.63,167.47-20.4,203.87,0,0,33.46-10.11,55.55-21.54Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M413.37,787.91l-130.96-79.24c-40.74-25.1-94.12-12.42-119.22,28.32h0c-14.32,23.24-7.09,53.69,16.16,68.01l110.26,68.15,146.12,90.03c111.99,69,265.7,71.24,375.27,16.38,0,0,103.15-57.59,233.19-40.14v-260.09l-98.97-54.84c-110.46-61.72-251.59,43.18-251.59,43.18-53.78,35.43-99.18,58.29-161.77,70.2-23.28,4.43-51.97,4.11-73.31,13.57-26.49,11.73-47.91,31.77-54.61,60.77-4.7,20.35,4.14,45.79,21.67,57.62,23.76,16.05,59.48,10.4,85.91,7,65.25-8.37,129.35-26.14,190.41-50.42.79-.32,1.58-.63,2.38-.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M464.42,749.14l-142.18-83.36c-36.03-22.2-83.23-10.99-105.42,25.04l-3.88,8.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M546.64,735.05l-162.74-96.02c-32.6-20.09-74.35-12.82-98.44,15.44"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeHandholdingplant);
export default __webpack_public_path__ + "static/media/icone_handholdingplant.bd33b9b68bc599f98670c43e0d35b368.svg";
export { ForwardRef as ReactComponent };